import React from 'react'

import './loading.scss'

const LoadingAnimation = () => <div className='loading-animation' />

export default LoadingAnimation
